import React from "react";
import Tooltip from "react-simple-tooltip";

class SimpleTooltip extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { keepRefresh = false } = this.props;
    return nextProps.tooltipText !== this.props.tooltipText || keepRefresh;
  }

  render() {
    const { tooltipText, children, place, tooltipElement } = this.props;

    return (
      <Tooltip
        placement={place || "top"}
        background={
          !tooltipText || tooltipText === "" ? "" : "rgba(0, 0, 0, 0.9)"
        }
        border="transparent"
        content={
          tooltipElement || (
            <div className="whitespace-no-wrap text-center text-xs">
              {tooltipText}
            </div>
          )
        }
        padding={8}
        radius={4}
      >
        {children}
      </Tooltip>
    );
  }
}

export default SimpleTooltip;
